var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main-layout", [
    _c(
      "div",
      { staticClass: "container azSize" },
      [
        _c("H1", { staticClass: "pageTitle isPoppins" }, [
          _vm._v("Slink Details")
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "wideLimitWidth top20 accSettingsForm",
            attrs: { id: "slinkCard" }
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "is-pulled-right has-text-weight-bold has-text-white",
                attrs: { id: "backToList" },
                on: { click: _vm.hideDetail }
              },
              [
                _c("i", { staticClass: "fa fa-arrow-alt-circle-left " }),
                _vm._v(" Back To List\n            ")
              ]
            ),
            _c("br"),
            _vm._v(" "),
            !_vm.payLoad.isTrial
              ? _c(
                  "button",
                  {
                    staticClass:
                      "button is-small  is-pulled-right top20 is-warning",
                    on: {
                      click: function($event) {
                        return _vm.cancelReinstateSubscr(_vm.payLoad.status)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.slinkActionLabel))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.payLoad.isTrial
              ? _c(
                  "button",
                  {
                    staticClass: "button   is-pulled-right top20 is-warning",
                    on: { click: _vm.purchase }
                  },
                  [_c("b", [_vm._v("Purchase Slink")])]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "slinkCard" }, [
              _c(
                "div",
                { staticClass: "topPart", attrs: { id: "slinkHeader" } },
                [
                  _c("header", { staticClass: "has-text-white" }, [
                    _c(
                      "div",
                      {
                        staticClass: "is-size-1  bottom10 has-text-yell top-20"
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/img/chevronsW.png"),
                            width: "30"
                          }
                        }),
                        _c("span", [
                          _vm._v(_vm._s(_vm.payLoad.slink.toLowerCase()) + " "),
                          _c(
                            "span",
                            { staticClass: "is-size-4 has-text-grey" },
                            [
                              _vm._v(
                                _vm._s(_vm.payLoad.isTrial ? "(Trial)" : "")
                              )
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "button is-small top10 is-warning right10 ",
                        on: {
                          click: function($event) {
                            _vm.showAnalytics(
                              _vm.payLoad.slink.toLowerCase(),
                              $event,
                              _vm.payLoad.code
                            )
                          }
                        }
                      },
                      [_c("i", { staticClass: "fas fa-chart-bar is-size-5" })]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "has-text-right" }, [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.payLoad.status ==
                                _vm.constants.status.SlinkInGracePeriod
                                  .longCode,
                              expression:
                                "payLoad.status == constants.status.SlinkInGracePeriod.longCode"
                            }
                          ],
                          staticClass:
                            "is-italic has-text-weight-normal has-text-danger left30"
                        },
                        [_vm._v("Disabled due to Subscription Payment Failure")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "is-size-7 left30" }, [
                        _vm._v(
                          "Plan: " +
                            _vm._s(_vm._f("planFilter")(_vm.payLoad.code))
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.payLoad.status !=
                                _vm.constants.status.SlinkInGracePeriod
                                  .longCode,
                              expression:
                                "payLoad.status != constants.status.SlinkInGracePeriod.longCode"
                            }
                          ],
                          staticClass: "is-size-7 left30"
                        },
                        [
                          _vm._v(
                            "Status: " +
                              _vm._s(_vm._f("statusString")(_vm.payLoad.status))
                          )
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.payLoad.isTrial
                        ? _c("div", { staticClass: "is-size-7 left30" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("actionString")(_vm.payLoad.status)
                              ) +
                                " " +
                                _vm._s(
                                  _vm.az.dateCalc(
                                    _vm.payLoad.createDate,
                                    _vm.payLoad.code
                                  )
                                )
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.payLoad.isTrial
                        ? _c("div", { staticClass: "is-size-7 left30" }, [
                            _vm._v(
                              "Expires: " +
                                _vm._s(
                                  _vm.az.dateConvertAdd30(
                                    _vm.payLoad.createDate
                                  )
                                )
                            )
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "slinkUrlContainer  posRel top5",
                        on: { click: _vm.editSlink }
                      },
                      [
                        _c("div", {}, [
                          _c(
                            "div",
                            { staticClass: "left20  is-size-4  isPoppins" },
                            [
                              _c("img", {
                                staticClass: "right3",
                                attrs: {
                                  src: require("@/assets/img/chevronsW.png"),
                                  width: "18"
                                }
                              }),
                              _c("b", { staticClass: "has-text-yell" }, [
                                _vm._v(_vm._s(_vm.payLoad.slink.toLowerCase()))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "is-size-8 has-text-light left20" },
                            [
                              _c("b", [
                                _vm._v(
                                  "slink.com/" +
                                    _vm._s(_vm.payLoad.slink.toLowerCase())
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "columns" }, [
                          _c("div", { staticClass: "column is-two-thirds" }, [
                            _c("div", { staticClass: "left35 subDescBlock" }, [
                              _c(
                                "div",
                                { staticClass: "is-inline-block subCardIcon" },
                                [
                                  _c("i", {
                                    class:
                                      "fa fa-" + _vm.chooseIcon(_vm.payLoad.url)
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "slinkContainerDisplayUrl top8 is-size-6  has-text-white is-inline-block"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.uFilter(_vm.payLoad.url) ||
                                        "unassigned"
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "is-size-5 top-5" }, [
                                _vm._v(_vm._s(_vm.payLoad.description || "--"))
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "column is-one-third has-text-left mngSlinkPageOnCol mobileNoBorders"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "top10 slinksPageDiv mobileNoBorders left10"
                                },
                                [
                                  _vm._v("SlinkPage: "),
                                  _c("span", { staticClass: "isPoppins" }, [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.payLoad.linksPage ? "on" : "off"
                                        )
                                      )
                                    ])
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", {}, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "qrIconDiv top10 left10 is-inline-block",
                                    on: {
                                      click: function($event) {
                                        _vm.doQR(
                                          _vm.payLoad.slink.toLowerCase(),
                                          _vm.payLoad.url,
                                          $event
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-qrcode has-text-white"
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "is-size-6" }, [
                                      _vm._v("Create QR")
                                    ])
                                  ]
                                )
                              ])
                            ]
                          )
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.payLoad.url && !_vm.isLoading,
                          expression: "!payLoad.url && !isLoading"
                        }
                      ],
                      staticClass: "has-text-light top10 is-size-5"
                    },
                    [
                      _c("i", { staticClass: "fa fa-arrow-up has-text-yell" }),
                      _vm._v(" "),
                      _c("i", [
                        _vm._v(
                          "Your slink is not pointing anywhere yet. Click on it and tell us where you would like to point it to enable redirection."
                        )
                      ])
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "isPoppins is-size-3 has-text-turk is-inline-block"
              },
              [
                _vm._v("subslinks  "),
                _c("i", {
                  staticClass: "fa fa-plus-square  handCursor addSub",
                  on: { click: _vm.newSub }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.subslinks.length < 1 && !_vm.isLoading,
                    expression: "subslinks.length < 1 && !isLoading"
                  }
                ],
                staticClass: "has-text-light top10 is-size-5"
              },
              [
                _c("i", { staticClass: "fa fa-arrow-up has-text-yell" }),
                _vm._v(" "),
                _c("i", [
                  _vm._v("Click the plus sign to add your first subslink")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "is-inline-block has-text-white is-pulled-right top10"
              },
              [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.subslinks.length) +
                      " of " +
                      _vm._s(
                        Object.keys(_vm.$root.newPlans).length ? _vm.limit : "-"
                      ) +
                      " used"
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "top10", attrs: { id: "subs" } }, [
              _c(
                "div",
                { staticClass: "slinkContainerComp" },
                [
                  _vm._l(_vm.subslinks, function(item, i) {
                    return _c(
                      "div",
                      {
                        key: i,
                        staticClass: "slinkContainer",
                        on: {
                          click: function($event) {
                            _vm.editSub(
                              item.name.toLowerCase(),
                              item.url.toLowerCase(),
                              item.subslinkId,
                              item.showInLinksPage,
                              item.description,
                              item.subslinkId
                            )
                          }
                        }
                      },
                      [
                        _c("div", {}, [
                          _c(
                            "div",
                            { staticClass: "left20   is-size-4  isPoppins" },
                            [
                              _c("img", {
                                staticClass: "right3",
                                attrs: {
                                  src: require("@/assets/img/chevronsW.png"),
                                  width: "18"
                                }
                              }),
                              _c("b", [
                                _c("span", { staticClass: "has-text-yell" }, [
                                  _vm._v(_vm._s(item.slinkName) + ":")
                                ]),
                                _vm._v(_vm._s(item.name))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "is-size-8 has-text-light left20" },
                            [
                              _c("b", [
                                _vm._v(
                                  "slink.com/" +
                                    _vm._s(
                                      _vm.payLoad.slink.toLowerCase() +
                                        ":" +
                                        item.name
                                    )
                                )
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "columns bottom5" }, [
                          _c("div", { staticClass: "column is-two-thirds" }, [
                            _c("div", { staticClass: "left35 subDescBlock" }, [
                              _c(
                                "div",
                                { staticClass: "is-inline-block subCardIcon" },
                                [
                                  _c("i", {
                                    class: "fa fa-" + _vm.chooseIcon(item.url)
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "slinkContainerDisplayUrl top8 is-size-6  has-text-white is-inline-block"
                                },
                                [_vm._v(_vm._s(_vm.uFilter(item.url)))]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "is-size-5 top-5" }, [
                                _vm._v(_vm._s(item.description || "--"))
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "column mobileNoBorders borderLeftWhite"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "is-size-6 top5 has-text-white left10"
                                },
                                [
                                  _vm._v("show in SlinkPage: "),
                                  _c("span", { staticClass: "isPoppins" }, [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          item.showInLinksPage ? "on" : "off"
                                        )
                                      )
                                    ])
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "qrIconDiv is-inline-block  top10 left10",
                                  on: {
                                    click: function($event) {
                                      _vm.doQR(
                                        _vm.payLoad.slink.toLowerCase() +
                                          ":" +
                                          item.name,
                                        item.url,
                                        $event
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-qrcode has-text-white"
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "is-size-6" }, [
                                    _vm._v("Create QR")
                                  ])
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "is-pulled-right right10" },
                            [_c("div", { staticClass: "top25 right10" })]
                          )
                        ])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c("div")
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("br"),
            _c("br"),
            _c("br"),
            _c("br"),
            _c("br")
          ]
        ),
        _vm._v(" "),
        _c("br"),
        _c("br")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-181bb163", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-181bb163","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/MngDetail.vue
// module id = null
// module chunks = 